// src/app/blog/resolver/article.resolver.ts
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { take, delay, filter, map } from 'rxjs/operators';
import * as articleActions from "../ng-store/action/article.action";
import * as fromRoot from "../ng-store/index";
import { ArticleState } from '../ng-store/reducer/article.reducer';

@Injectable({ providedIn: 'root' })
export class ArticleResolver  {
  constructor(private store: Store) {}

  resolve(route: ActivatedRouteSnapshot): Observable<boolean> {
    const slug = route.paramMap.get('slug');
    if (!slug) {
      return of(false);
    }

    // Dispatch the action to load the article
    this.store.dispatch(articleActions.article({ slug }));

    // Wait for the article to be loaded successfully or fail
    return this.store.select(fromRoot.articleSelector).pipe(
      filter((state: ArticleState) => state.isDownloadingSuccess || state.isDownloadingFailure),
      take(1),
      map((state: ArticleState) => state.isDownloadingSuccess)
    );
  }
}
